var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconSongNext = function SvgIconSongNext(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0308 9.55444L5.21097 4.50357C4.72787 4.19111 4.12603 4.18271 3.63557 4.48157C3.14511 4.78043 2.8418 5.34035 2.8418 5.94723V16.0528C2.8418 16.6597 3.14511 17.2196 3.63557 17.5185C4.12603 17.8173 4.72787 17.8089 5.21097 17.4965L13.0308 12.4418C13.5013 12.1372 13.7892 11.5893 13.7892 10.9981C13.7892 10.4069 13.5013 9.85896 13.0308 9.55444Z",
    fill: "#3C3C3B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.7891,
    y: 4.26318,
    width: 3.36842,
    height: 13.4737,
    rx: 1.68421,
    fill: "#3C3C3B"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconSongNext);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/icon-song-next.317c8d61727bdad4933bf2cfc728ba52.blank.svg";